/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AllergySymptom from './allergy-symptom';
import AllergySymptomDetail from './allergy-symptom-detail';
import AllergySymptomUpdate from './allergy-symptom-update';
import AllergySymptomDeleteDialog from './allergy-symptom-delete-dialog';

const AllergySymptomRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AllergySymptom />} />
    <Route path="new" element={<AllergySymptomUpdate />} />
    <Route path=":id">
      <Route index element={<AllergySymptomDetail />} />
      <Route path="edit" element={<AllergySymptomUpdate />} />
      <Route path="delete" element={<AllergySymptomDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AllergySymptomRoutes;
